var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitmart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 313.91 281",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m202 136.19a84.68 84.68 0 0 0 18.25-52.65c0-47-38.08-83.54-85.06-83.54h-103.29v10.63h101c41.52 0 75.18 32.15 75.18 73.67a74.88 74.88 0 0 1 -14.8 44.81z",
    fill: "#55a49f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m190.48 127.39a61.34 61.34 0 0 0 17.61-43.09 61.52 61.52 0 0 0 -61.51-61.52h-87.34v10.64h89.61a50.12 50.12 0 0 1 50.15 50.12 50 50 0 0 1 -17.86 38.36z",
    fill: "#4a8c89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m173.63 119.37c14.37-6.28 25.37-19.96 25.37-35.83 0-21.81-20.72-39.49-42.53-39.49h-75.97v6.07h75.19c18 0 35.69 14.63 35.69 32.66 0 14.61-11.58 27-25.57 31.15z",
    fill: "#5aaba5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1.52 270.37h16.71v10.63h-16.71z",
    fill: "#4a8c8a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.23 249.1h66.83v7.59h-66.83z",
    fill: "#5aaba6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m18.23 202.02h71.39v6.08h-71.39z",
    fill: "#4b8f8e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m103.29 202.02h45.57v6.08h-45.57z",
    fill: "#7cc6c7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m31.9 180.75h24.3v6.08h-24.3z",
    fill: "#5ab5b4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m69.87 180.75h78.98v6.08h-78.98z",
    fill: "#428989"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m95.69 85.06h51.64v6.08h-51.64z",
    fill: "#549391"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m34.94 44.05h28.86v6.08h-28.86z",
    fill: "#306563"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m42.53 66.83h106.32v6.08h-106.32z",
    fill: "#64b9b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m15.19 85.06h65.31v6.08h-65.31z",
    fill: "#7fd6d5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m33.42 268.85v10.63h115.43c47 0 85.06-36.56 85.06-83.54a85.06 85.06 0 0 0 -85.06-85.06h-74.42v9.12h72.15a75.19 75.19 0 0 1 75.18 75.19c0 41.53-33.66 73.67-75.18 73.67z",
    fill: "#55a49f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m51.64 133.66v10.64h110.88a50.12 50.12 0 0 1 50.13 50.12 50.13 50.13 0 0 1 -50.13 50.13h-65.31v12.15h63a61.51 61.51 0 0 0 61.51-61.52 61.52 61.52 0 0 0 -61.51-61.52z",
    fill: "#4a8c89"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m83.54 156.45v6.07h85.82c18 0 35.69 14.63 35.69 32.66 0 18-17.65 32.66-35.69 32.66h-169.36v7.59h170.12c21.81 0 42.53-17.68 42.53-39.49 0-21.81-20.72-39.49-42.53-39.49z",
    fill: "#5aaba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitmart);
export default __webpack_public_path__ + "static/media/bitmart.6198275be7874021e9c35b2f315216e6.svg";
export { ForwardRef as ReactComponent };